module.exports = __webpack_public_path__ + "static/img_0940-95bce82ea83d61db37a97a2789e222df.webp";